import { withSvgIcon } from './withSvgIcon';

export const NavBarBilling = withSvgIcon(
  <>
    <path
      d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H17V8M4 8L4 13L4 15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H20V8C19.1214 8 17.7827 8 17 8M4 8C9.16822 8 12.3958 8 17 8"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M14 13.5H17.5" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
